import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { pluralize } from '@aytm/app/stats/lib/util/helpers'

import style from '@aytm/app/stats/page/comments/comments/styles/OEItem.module.scss'

const getMNResponseSummary = (node, answerVariants) =>
  Object.keys(node)
    .reduce((acc, key) => {
      const match = key.match(/^a(\d+)$/)
      if (!match || !node[key]?.x) return acc

      const position = Number(match[1])
      const av = answerVariants.find(v => v.position === position)
      if (!av) return acc

      acc.push({ position, name: av.text || '', qty: node[key]?.val || 0 })
      return acc
    }, [])
    .sort((a, b) => a.position - b.position)

const Summary = ({ node, question }) => {
  const mnOrderSummary = useMemo(
    () => getMNResponseSummary(node, question.answerVariants || []),
    [node, question.answerVariants]
  )

  if (!mnOrderSummary.length) return null

  return (
    <div className={style['comment-answer-summary']}>
      {mnOrderSummary.map(item => (
        <div key={item.position}>
          {/* name is encoded at rest; innerHTML decodes once — decodeText here would double-decode and un-sanitize */}
          <span dangerouslySetInnerHTML={{ __html: item.name || '' }} /> – {item.qty} {pluralize(item.qty, 'pc', 'pcs')}
        </div>
      ))}
    </div>
  )
}

Summary.propTypes = {
  node: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired
}

Summary.displayName = 'Summary'

export default Summary
